<template>
  <div class="sections-container" >

    <div class="header-sections">

      <span class="title-section">
        {{ busines ? busines.name : 'Dashboard' }}
      </span>

      <div class="filter-container-dash">

          <div v-if="busines" class="autocomplete-container">
            <span class="title-filter">POS:</span>
            <v-select
              style="width: 150px;"
              v-model="filterSelected"
              :items="filterData"
              item-title="label"
              item-value="value"
              density="compact"
              hide-details="auto"
              variant="solo"
              class="no-bg"
            />

          </div>

        <DatePicker v-model:dates="dates"/>
      </div>
    </div>

    <MasterDashboard v-if="!busines"/>

    <AdminDashboard v-if="busines"
      :busines="busines._id"
      :dates="dates"
      :terminal="filterSelected"
      />

  </div>
</template>
<script>
import MasterDashboard from '../dashboards/MasterDashboard.vue'
import AdminDashboard from '../dashboards/AdminDashboard.vue'
import DatePicker from '../dashboards/DatePicker.vue'
import terminalsApi from '@/api/terminalsApi'
export default {
  name: 'CommerciaVueDashboard',
  components: {
    MasterDashboard,
    AdminDashboard,
    DatePicker
  },
  data () {
    const today = new Date()
    return {
      business: this.$store.getters.business,
      dates: { start: today, end: today },
      filterSelected: 'all',
      filterData: [{ value: 'all', label: 'Todos' }]
    }
  },
  computed: {
    busines () {
      return this.$store.getters.business
    }
  },
  mounted () {
    if (this.busines && this.busines._id) {
      this.getPos()
    }
  },
  watch: {
    busines (newVal) {
      if (newVal && newVal._id) {
        this.getPos()
      }
    }
  },
  methods: {
    async getPos () {
      // Evita errores si no hay negocio aún
      if (!this.busines || !this.busines._id) return

      this.filterData = [{ value: 'all', label: 'Todos' }]

      try {
        const listPos = await terminalsApi.list(this.busines._id, '')
        for (const item of listPos) {
          this.filterData.push({ value: item._id, label: item.name })
        }
      } catch (error) {
        console.error('Error al obtener POS:', error)
      }
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/sections.css';
  @import '@/assets/styles/inputs.css';
</style>
